// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1gv8R","row":"Node_row__9tp1_","label":"Node_label__3g8Ny","footer":"Node_footer__YQ_-I"};